import axios from 'axios';
import history from '../history';
import {CONFIG} from '../config';

const user = JSON.parse(localStorage.getItem("user"));
const instance = axios.create({
    baseURL: CONFIG.ACCOUNT_MANAGEMENT_HOST,
    headers: {
        'Accept':  'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + (user == null ? "" : user.access_token)
    }
});

instance.defaults.withCredentials = false;
instance.interceptors.response.use(response => {    
    return response;
}, error => {
    localStorage.removeItem("user")
    history.push('/login')
});

export default instance;